import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/constants";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/site");
      setSite(data);
    } catch (e) {
      setSite({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SiteContext.Provider value={{ site: site || {}, loading, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  const ctx = useContext(SiteContext);
  if (!ctx) return { site: {}, loading: true, refresh: () => {} };
  return ctx;
}
